var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"mb-5",attrs:{"outlined":"","color":"secondary","small":""},on:{"click":_vm.createSample}},[_vm._v("Create")]),_c('Table'),_c('EditForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }